/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/* tslint:disable */

module DealerwareWebContent {

    "use strict";

    getDealerwareWebContentModule()
        .constant(
            'coordinateDimensions', [
                'signatureX',  'signatureY',  'signatureWidth',  'signatureHeight',
                'dateX', 'dateY', 'dateWidth', 'dateHeight', 'selected'
            ]
        )
        .constant(
            'agreementPageKeyMap', {
                id              : 'id',
                number          : 'page',
                signatureX      : 'sig_x',
                signatureY      : 'sig_y',
                signatureWidth  : 'sig_width',
                signatureHeight : 'sig_height',
                dateX           : 'date_x',
                dateY           : 'date_y',
                dateWidth       : 'date_width',
                dateHeight      : 'date_height',
                selected        : 'selected'
            }
        );

    export interface IAgreement {
        id         : number;
        fileName   : string;
        fileUrl    : string;
        createdAt  : string;
        pages      : IAgreementPageArray;
    }

    export interface IAgreementPageArray extends Array<IAgreementPage> {
        [index: number] : IAgreementPage;
    }

    export interface IAgreementPage {
        id                 : number;
        lastSelectedIndex? : number;
        number             : number;
        thumbnailUrl       : string;
        thumbnailWidth     : number;
        thumbnailHeight    : number;
        signatureX?        : number;
        signatureY?        : number;
        signatureWidth?    : number;
        signatureHeight?   : number;
        dateX?             : number;
        dateY?             : number;
        dateWidth?         : number;
        dateHeight?        : number;
        selected           : boolean;
    }

    export class SettingsLoanerAgreementController {

        public static $inject : string[ ] = [
            '$q',
            '$timeout',
            '$state',
            '$scope',
            '$dealerwareLoading',
            '$dealerwareNotification',
            '$mobilityCompanyAuthentication',
            'DealerwareLoanerAgreementModel',
            'SettingsLoanerAgreementService',
        ];

        public loading: boolean = true;

        public activePage: string;


        constructor(
            private $q                              : ng.IQService,
            private $timeout                        : ng.ITimeoutService,
            private $state                          : any,
            private $scope                          : ng.IScope,
            private $dealerwareLoading              : any,
            private $dealerwareNotification         : any,
            private $auth                           : any,
            private DealerwareLoanerAgreementModel  : any,
            private service                         : any
        ) {

            var that = this;

            service.$state = $state;

            this.$scope.$watch( ( ) => {
                return that.$state.current.data.page;
            }, ( currentPage: string) => {
                that.activePage = currentPage;
            }, true);

            this.service.agreement = undefined;
            this.service.locationId = this.$auth.location.id;
            this.service.onboarding = !JSON.parse(localStorage.getItem('onboarding') || "");

            this.$timeout( ( ) => {
                this.service.getAgreement()
                    .then( result => {
                        // If an agreement is found, getAgreement resolves with an empty call.
                        // If no agreement is found, getAgreement resolves with the API response.
                        const isAgreementUploaded = result === undefined;
                        return that.service.resolveLoanerAgreementState (that.$state, isAgreementUploaded);
                    } )
                    .then( ( ) => {
                        that.loading = false;
                        return that.$q.when();
                    })
                    .catch( ( response: any ) => {

                        if (response.status !== 404) {
                            that.$dealerwareNotification.apiError (response);
                        }
                    });
            });
        }

        public uploadFile (chosenFile: any ) : void {

            var that = this;

            var wrongFileTypeMessage = 'Error, there was a problem with your file. '
                + 'Driver Agreement Upload supports .pdf files; '
                + 'perhaps your file is of the wrong type?';

            if (chosenFile === null) {
                that.$dealerwareNotification.error (wrongFileTypeMessage);
                return;
            }

            var loader = this.$dealerwareLoading.show ('Uploading...');

            this.service.uploadFile (chosenFile, this.service.locationId)
                .then( ( ) => {

                    loader.close();
                    that.$dealerwareNotification.toast ('Upload succeeded')
                        .then( ( ) => {

                            // Automatically select and save the page if the document only
                            // contains one page.
                            //
                            if (that.service.agreement.pages && that.service.agreement.pages.length === 1) {
                                that.service.agreement.pages[0].selected = true;
                                that.service.savePage (that.service.agreement.pages[0].id)
                                    .then( () => {
                                        that.service.goToPage (that.$state, 'set-signature');
                                    });
                            }
                            else {
                                that.$state.go('shortcuts.settingsLoanerAgreementSelectPage');
                            }
                        });
                })
                .catch( ( ) => {
                    loader.close();
                    that.$dealerwareNotification.error (wrongFileTypeMessage);
                });
        }
    }

    getDealerwareWebContentModule().controller(
        'SettingsLoanerAgreementController',
        SettingsLoanerAgreementController
    );


    export class SettingsLoanerAgreementService {

        private utils: any;

        private getAgreementRun                     : boolean = false;
        //private getAgreementSignatureLocationsRun   : boolean = false;

        private agreement       : IAgreement;
        private locationId      : number;

        private steps: any[];
        private activeStep: number;

        private originalPage : any = { };

        private $state: any;

        constructor(
            public DataUtils                        : any,
            public $q                               : any,
            public DealerwareLoanerAgreementModel   : any,
            public reverseRouteShortcuts            : any,
            public agreementPageKeyMap              : any,
            public coordinateDimensions             : string[],
            public MicroFrontendOrigin              : string
        ) {

            this.utils = this.DataUtils.getInstance();

            this.activeStep = 0;

            // Structure used to determine state change of page, and signature/date locations.
            //
            Object.keys(this.agreementPageKeyMap).forEach( ( pageKey: string ) => {
                this.originalPage[pageKey] = undefined;
            });
            this.originalPage.page = undefined;

            this.steps = [
                /*
                 *  0 = Upload
                 */
                { name          : 'upload',
                  title         : 'Upload',
                  instructions  : 'Drag and drop your driver agreement onto this page, or choose a file from your computer',
                  progress      : 20,
                  route         : 'settingsLoanerAgreementUpload',
                  checkFunction : this.isUploaded
                },
                /*
                 *  1 = Page
                 */
                { name          : 'select-page',
                  title         : 'Select Page',
                  instructions  : 'Select the page of the contract that you would like to place signature and date',
                  progress      : 0,
                  route         : 'settingsLoanerAgreementSelectPage',
                  checkFunction : this.isPageSelected
                },
                /*
                 *  2 = Signature
                 */
                { name          : 'set-signature',
                  title         : 'Define the Signature Area',
                  instructions  : 'Drag a box around the zone in which the signature will be placed',
                  progress      : 0,
                  route         : 'settingsLoanerAgreementSetSignature',
                  checkFunction : this.isSignatureDefined
                },
                /*
                 *  3 = Date
                 */
                { name          : 'set-date',
                  title         : 'Define the Date Area',
                  instructions  : 'Drag a box around the zone in which the date will be placed',
                  progress      : 0,
                  route         : 'settingsLoanerAgreementSetDate',
                  checkFunction : this.isDateDefined
                },
                /*
                 *  4 = Page (via View = 1)
                 */
                { name          : 'incomplete-select-page',
                  title         : 'Driver Agreement Configuration Incomplete',
                  instructions  : 'Select page for signature and date, then define placements.',
                  progress      : 0,
                  stepEquivalent: 1,
                  route         : 'settingsLoanerAgreementView'
                },
                /*
                 *  5 = Signature (via View = 2)
                 */
                { name          : 'incomplete-set-signature',
                  title         : 'Driver Agreement Configuration Incomplete',
                  instructions  : 'Page selected, now define signature and date placements.',
                  progress      : 0,
                  stepEquivalent: 2,
                  route         : 'settingsLoanerAgreementView'
                },
                /*
                 *  6 = Date (via View = 3)
                 */
                { name          : 'incomplete-set-date',
                  title         : 'Driver Agreement Configuration Incomplete',
                  instructions  : 'Page selected and signature placement defined, now define date placement.',
                  progress      : 0,
                  stepEquivalent: 3,
                  route         : 'settingsLoanerAgreementView'
                },
                /*
                 *  7 = Finished
                 */
                { name          : 'complete',
                  title         : 'Completed Driver Agreement',
                  instructions  : 'You have successfully configured your driver agreement.',
                  progress      : 0,
                  stepEquivalent: 4,
                  route         : 'settingsLoanerAgreementView'
                }
            ];
        }

        // TODO: condense, resolve $state proliferation.
        //
        public resolveLoanerAgreementState ( $state: any, loanerAgreementUploaded: boolean) : any {
            if (loanerAgreementUploaded) {

                if (this.isThisStepUpload ($state)) {
                    this.goToView ($state);
                }
                else if (! this.isPageSelected()) {

                    var newStep = 'incomplete-select-page';
                    if (this.getStepNameForRoute ($state) === 'select-page') {
                        newStep = 'select-page';
                    }
                    else {
                        newStep = 'incomplete-select-page';
                        this.goToView ($state);
                    }
                    this.setStepData (newStep);
                }

                else if (! this.isSignatureDefined()) {

                    var newStep = 'incomplete-set-signature';
                    var stepMatch = this.getStepNameForRoute ($state)
                        .match(
                            /^(select\-page|set\-signature)$/
                        );
                    if (stepMatch) {
                        newStep = stepMatch[1];
                    }
                    else {
                        this.goToView ($state);
                    }
                    this.setStepData (newStep);
                }

                else if (! this.isDateDefined()) {

                    var newStep = 'incomplete-set-date';
                    var stepMatch = this.getStepNameForRoute ($state)
                        .match(
                            /^(select\-page|set\-signature|set\-date)$/
                        );
                    if (stepMatch) {
                        newStep = stepMatch[1];
                    }
                    else {
                        this.goToView ($state);
                    }
                    this.setStepData (newStep);
                }

                else {
                    this.setStepData (
                        this.isThisRouteView ($state) ? 'complete' : this.getStepNameForRoute ($state)
                    );
                }

                //this.setStepData (stepMatch || 'complete')

                return this.$q.when();
            }

            if (! this.isUploaded()) {
                this.goToUpload ($state);
            }
            else {
                return this.$q.when();
                //return this.getAgreementSignatureLocations();
            }
        }

        public getAgreement () : ng.IPromise<{}> {

            this.getAgreementRun = true;

            var defer = this.$q.defer();

            var that = this;

            this.DealerwareLoanerAgreementModel.getAgreement ({
                params: {
                    location_id : that.locationId
                },
                promise: true
            })
                .then( ( rawAgreement: any ) => {
                    that.agreement = that.mapAgreementResponse (rawAgreement);
                    defer.resolve();
                })
                .catch( ( response: any ) => {
                    if (response.status === 404) {
                        defer.resolve (response);
                    }
                    defer.reject (response);
                });

            return defer.promise;
        }

        public mapAgreementResponse ( rawAgreement: any ) : any {

            return <IAgreement> {
                id                  : rawAgreement.data.id,
                fileName            : rawAgreement.data.pdf_agreement_name,
                fileUrl             : rawAgreement.data.pdf_agreement_url,
                createdAt           : rawAgreement.data.created_at,
                pages               : <IAgreementPageArray> rawAgreement.data.agreement_pages
                    .map ( ( rawPage: any ) => {

                        return <IAgreementPage> angular.extend( {
                            thumbnailUrl        : rawPage.thumbnail + '?' + Math.round(Math.random() * 1000000000),
                            thumbnailWidth      : rawPage.page_width,
                            thumbnailHeight     : rawPage.page_height
                        }, ( ( ) => {
                            var page: any = { };
                            Object.keys(this.agreementPageKeyMap).forEach( ( pageKey: string ) => {
                                if (rawPage[this.agreementPageKeyMap[pageKey]] !== null) {
                                    page[pageKey] = rawPage[this.agreementPageKeyMap[pageKey]];
                                }
                            });
                            if (page.selected) {
                                angular.extend(this.originalPage, page);
                            }
                            return page;
                        })());
                    })
            };
        }

        public mapAgreementPagesRequest () : any {

            var that = this;

            var pageDimensionsData : any = { };

            // Copying data rather than sending agreement.pages directly to freeze it against both further modification
            // from what gets sent to the backend, and also restored to that selfsame data structure upon return.
            //
            this.agreement.pages.forEach( ( page: any, i: number ) => {

                // Do forward PDF coordinate bottom-left conversion here
                //
                Object.keys(that.agreementPageKeyMap).forEach( ( pageKey: string ) => {

                    if (page.selected) {

                        // Using 0 for the eight coordinate fields as a positive assertion
                        // to the endpoint that this page has been selected, since the
                        // agreement_pages record doesn't contain an explicit field to that effect.
                        //
                        // This is a terrible terrible hack forced on this code by regrettable
                        // circumstance.  Hopefully this can be rectified someday via more coherent
                        // backend design.
                        //
                        if (this.coordinateDimensions.indexOf(pageKey) !== -1) {
                            var apiKey = that.agreementPageKeyMap[pageKey];
                            pageDimensionsData[apiKey] = page[pageKey];
                        }
                        if (! isNaN(page.lastSelectedIndex)) {
                            pageDimensionsData.lastSelectedIndex = page.lastSelectedIndex;
                        }
                    }
                })
            });

            return pageDimensionsData;
        }

        public mapAgreementPagesResponse ( rawSignatureData: any ) : any {

            var pageSignatureData: any = { };

            // Signature: add coordinates to page.
            //
            if (rawSignatureData.data.selected) {
                angular.extend(pageSignatureData, {
                    signatureX        : rawSignatureData.data[this.agreementPageKeyMap.signatureX],
                    signatureY        : rawSignatureData.data[this.agreementPageKeyMap.signatureY],
                    signatureWidth    : rawSignatureData.data[this.agreementPageKeyMap.signatureWidth],
                    signatureHeight   : rawSignatureData.data[this.agreementPageKeyMap.signatureHeight]
                });
            }

            // Date: add coordinates to page.
            //
            if (rawSignatureData.data.selected) {
                angular.extend(pageSignatureData, {
                    dateX       : rawSignatureData.data[this.agreementPageKeyMap.dateX],
                    dateY       : rawSignatureData.data[this.agreementPageKeyMap.dateY],
                    dateWidth   : rawSignatureData.data[this.agreementPageKeyMap.dateWidth],
                    dateHeight  : rawSignatureData.data[this.agreementPageKeyMap.dateHeight]
                });
            }

            var selectedPageNumber = rawSignatureData.data.agreement_page.page;

            angular.extend(
                this.agreement.pages[selectedPageNumber - 1], pageSignatureData
            );

            // Setting the original data load for the return signature_locations to compare
            // against for changes and state based on (no)changes
            //
            angular.extend(this.originalPage, pageSignatureData, {
                number: selectedPageNumber
            });

            // Undefine lastSelectedIndex, if any, to reset state.
            //
            delete this.agreement.pages[selectedPageNumber - 1].lastSelectedIndex;
        }

        private getChangedPageCoordinateData ( selectedPage: any ) : any {

            var changedCoordinateKeys : any = { };

            Object.keys(this.agreementPageKeyMap).forEach( ( coordKey: string ) => {

                // Comparing undefineds is ok since undefined === undefined.
                //
                if ( (selectedPage && selectedPage[coordKey])
                     !== (this.originalPage[coordKey] && this.originalPage[coordKey])) {
                    changedCoordinateKeys[coordKey] = true;
                }
            });

            return changedCoordinateKeys;
        }

        public savePage ( pageId: number, data: any ) : ng.IPromise<void> {

            // Guy I worked with (and liked) liked it this way, and 'self' reminds me of Perl, which I
            // still have PTSD about, so it seemed like a reasonable substitute.
            //
            var that = this;

            var defer = this.$q.defer();

            // Data to save can be passed in or figured out from the selected element
            // in this.agreement.pages.  It's passed in when needed to wipe out
            // the previously saved page, if any.
            //
            if (! data) {
                data = this.mapAgreementPagesRequest();
                var lastSelectedIndex = data.lastSelectedIndex;
                delete data.lastSelectedIndex;
            }

            var params : any = {
                location_id     : this.locationId,
                agreement_id    : this.agreement.id,
                page_id         : pageId
            };

            var updateAgreementPromise = this.DealerwareLoanerAgreementModel.updateAgreementPage ( {
                params  : params,
                data    : data,
                promise : true
            });

            updateAgreementPromise
                .then( ( rawSignatureData: any ) => {

                    if (rawSignatureData.data.agreement_page.id === pageId) {
                        this.mapAgreementPagesResponse (rawSignatureData);
                    }
                    // We didn't get back the same page as we saved to.  Something has gone
                    // terribly wrong.  And Lo! there was a great weeping and gnashing of teeth.
                    //
                    else {
                        throw { data: { message: 'Unknown error in saving agreement signature data' }};
                    }

                    this.$q.resolve()
                })
                .then( ( ) => {

                    // Blow away old selected page (by undefining zeros).
                    //
                    if (! isNaN(lastSelectedIndex)) {

                        this.savePage (
                            this.agreement.pages[lastSelectedIndex].id,
                            (( ) => {
                                var pageDimensionsData: any = { };
                                Object.keys(that.agreementPageKeyMap).forEach( ( pageKey: string ) => {

                                    var apiKey = that.agreementPageKeyMap[pageKey];

                                    if (apiKey === 'page') {
                                        pageDimensionsData[apiKey] = this.agreement.pages[lastSelectedIndex].number;
                                    }
                                    else if (apiKey === 'selected') {
                                        pageDimensionsData[apiKey] = false;
                                    }
                                });
                                return pageDimensionsData;
                            })()
                        );
                    }

                    defer.resolve();
                })
                .catch( ( response: any ) => {
                    defer.reject (response);
                });

            return defer.promise;
        }

        public getAgreementByContractId (locationId: number, contractId : string) : ng.IPromise<{}> {

            var defer = this.$q.defer();

            this.DealerwareLoanerAgreementModel.getAgreementByContractId ({
                params: {
                    location_id: locationId,
                    reservation_id: contractId
                },
                promise: true
            })
                .then( ( response : any ) => {
                    defer.resolve (response.data);
                })
                .catch( ( response : any ) => {
                    defer.reject (response);
                });

            return defer.promise;
        }

        public uploadFile ( chosenFile: any, locationId: number ) : ng.IPromise<{}> {

            var that = this;

            return chosenFile.upload({
                url : this.utils.bindEndpoint (
                    this.DealerwareLoanerAgreementModel.uploadAgreement.endpoint.replace(
                        /:location_id/, locationId
                    )
                ),
                data : { file: chosenFile }
            })
                .then( ( rawAgreement: any ) => {

                    that.agreement = that.mapAgreementResponse (rawAgreement);
                    return that.$q.resolve();
                });
        }

        /*
         *  0 = Upload
         *  1 = Page
         *  2 = Signature
         *  3 = Date
         *  4 = Page (via View = 1)
         *  5 = Signature (via View = 2)
         *  6 = Date (via view = 3)
         *  7 = Complete
         */
        public setStepData ( name?: string ) : void {

            var that = this;

            // When setting step data (page title, instructions, progress bar) for route 'view',
            //
            if (name === 'view') {

                var activeStep = this.getStepIndexForName('incomplete-select-page');

                if (this.isPageSelected()) {
                    activeStep = this.getStepIndexForName('incomplete-set-signature');
                }

                if (this.isSignatureDefined()) {
                    activeStep = this.getStepIndexForName('incomplete-set-date');
                }

                if (this.isDateDefined()) {
                    activeStep = this.getStepIndexForName('complete');
                }

                that.activeStep = activeStep;
            }
            else {

                $.each(this.steps, (i: number, step: any ) => {
                    if (step.name === name) {
                        that.activeStep = i;
                        return false;
                    }
                });
            }

            window.parent.postMessage({
                type: "done",
                data: that.activeStep
            }, that.MicroFrontendOrigin)

            // Allows View to show, in its progress bars, what the actual overall
            // progression is, by "simulating" previous steps.
            //
            var stepEquivalent      = that.steps[that.activeStep].stepEquivalent;
            var usingEquivalentStep = ! isNaN(stepEquivalent);
            var calculatedStep      = usingEquivalentStep ? stepEquivalent : that.activeStep;

            var activeStepProgressValue = usingEquivalentStep ? 0 : 20;

            // Loop through steps to figure out what each's progress bar value is.
            //
            $.each(this.steps, (i: number, step: any ) => {

                // checkFunction allows a step to be marked as finished (if it has been),
                // even if the user is viewing a step previous to it.
                //
                if (i < calculatedStep || (step.checkFunction && step.checkFunction.call(that))) {
                    that.steps[i].progress = 100;
                }
                else if (i > calculatedStep) {
                    that.steps[i].progress = 0;
                }
                else {
                    that.steps[i].progress = activeStepProgressValue;
                }
            });
        }

        // Checks for what the current state/route/url is.
        //
        public isThisStepUpload ( $state: any ) : boolean {
            return this.reverseRouteShortcuts[$state.current.name] === this.getRouteForStep('upload');
        }

        public checkThisStep ( $state: any, name: string ) : boolean {
            return this.reverseRouteShortcuts[$state.current.name] === this.getRouteForStep(name) ? true : false;
        }

        public getStepNameForRoute ( $state: any ) : string {
            return this.steps[this.getStepIndexForRoute($state)].name;
        }

        // Array.prototype.find would sure be less verbose...
        //
        public getStepIndexForRoute ( $state: any ) : number {

            var stepIndex = 0;
            this.steps.some( ( step: any ) => {

                if (step.route === this.reverseRouteShortcuts[$state.current.name]) {
                    return true;
                }
                stepIndex++;
            });

            return stepIndex;
        }

        public getStepIndexForName ( name: string ) : number {

            var stepIndex = 0;
            this.steps.some( ( step: any ) => {
                if (step.name === name) {
                    return true;
                }
                stepIndex++;
            });

            return stepIndex;
        }

        public getRouteForStep ( stepName: string ) : string {

            var stepIndex = 0;
            this.steps.some( ( step: any ) => {
                if (step.name === stepName) {
                    return true;
                }
                stepIndex++;
            });

            return this.steps[stepIndex].route;
        }

        // Checks for how much data, if any, we have in this.agreement (proxy for
        // how much of the wizard has been completed)
        //
        public isUploaded () : boolean {
            return (this.agreement && this.agreement.id) ? true : false;
        }

        public isPageSelected () : boolean {

            if (! this.agreement || !  this.agreement.pages) {
                return false;
            }

            return this.agreement.pages.some( ( page: any ) => {
                return page.selected;
            });
        }

        public isSignatureDefined () : boolean {

            if (! this.agreement || !  this.agreement.pages) {
                return false;
            }

            return this.agreement.pages.some( ( page: any ) => {
                return ! this.utils.isBlank(page.signatureX)
                    && page.signatureX !== 0;
            });
        }

        public isDateDefined () : boolean {

            if (! this.agreement || !  this.agreement.pages) {
                return false;
            }

            return this.agreement.pages.some( ( page: any ) => {
                return ! this.utils.isBlank(page.dateX)
                    && page.dateX !== 0;
            });
        }

        public isThisRouteView ( $state: any ) : boolean {
            return this.reverseRouteShortcuts[$state.current.name] === 'settingsLoanerAgreementView';
        }

        public goToUpload ( $state: any ) : void {
            this.goToPage ($state, 'upload');
        }

        public goToView ( $state: any ) : void {
            this.goToPage ($state, 'complete');
        }

        public goToPage ( $state: any, name: string ) : void {
            return $state.go('shortcuts.' + this.getRouteForStep (name));
        }
    }

    getDealerwareWebContentModule().factory('SettingsLoanerAgreementService', (
        DataUtils                       : any,
        $q                              : any,
        DealerwareLoanerAgreementModel  : any,
        reverseRouteShortcuts           : any,
        agreementPageKeyMap             : any,
        coordinateDimensions            : string[],
        MicroFrontendOrigin             : string,
    ) => new SettingsLoanerAgreementService (
             DataUtils, $q, DealerwareLoanerAgreementModel, reverseRouteShortcuts,
             agreementPageKeyMap, coordinateDimensions, MicroFrontendOrigin
         )
    );

    getDealerwareWebContentModule().filter('ByVisibleStepNumber', ( ) => {
        return ( steps: any ) => {
            return steps.filter( ( step: any ) => {
                return step.stepEquivalent === undefined;
            });
        }
    });

}
